import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import ConstructionRegistration from './ConstructionRegistration';
import ConstructionsHome from './ContractsAndConstructionsHome';

export enum EConstructionsRoutes {
  CONSTRUCTION_REGISTRATION = '/construction-registration'
}

const ContractsAndConstructions: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Route path={`${path}`} exact component={ConstructionsHome} />

      <Route
        path={`${path}${EConstructionsRoutes.CONSTRUCTION_REGISTRATION}`}
        component={ConstructionRegistration}
      />
    </>
  );
};

export default ContractsAndConstructions;
